import React, {useState, useContext, useEffect} from 'react'
import Logo from "../../img/logo-white.svg";
import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";
import { slide as Menu } from 'react-burger-menu'

function Header() {

    const [menuState, setMenuState] = useState()
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    var isMenuOpen = function(state) {
        return state.isOpen;
    };

    useEffect(() => {
        isMenuOpen === false ? setMenuState(true) : setMenuState(false)
    })

    function toggleMenu() {
        setMenuState(true)
    }

    return (
        <>
            <header className={offset >= 150 ? 'py-2 bg-[#E7E9EC] fixed top-0 left-0 w-full z-40' : 'py-3 bg-[#E7E9EC] fixed top-0 left-0 w-full z-40'} style={{transition: '0.5s'}}>
                <div className="container px-3 mx-auto flex justify-between items-center relative">
                    <a href="/" className="w-[100px]">
                        <img src={Logo} alt="Business Wisdom Summit"
                             className={offset >= '150' ? 'w-[70px]' : 'w-[100px]'} style={{transition: '0.5s'}}/>
                    </a>
                    <div className="block lg:hidden">
                        <Menu onStateChange={isMenuOpen} isOpen={menuState} pageWrapId={"page-wrap"}>
                            <nav id="page-wrap">
                                <ul>
                                    <li className="mb-3 text-[#e7e9ec]"><Link
                                        to="ebaut"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Про івент</Link>
                                    </li>
                                    <li className="mb-3 text-[#e7e9ec]"><Link
                                        to="speacers"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Спікери</Link>
                                    </li>
                                    <li className="mb-3 text-[#e7e9ec]"><Link
                                        to="programm"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Програма</Link>
                                    </li>
                                    <li className="text-[#e7e9ec]"><Link
                                        to="formats"
                                        id="head_paketu_clk"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Формати участі</Link>
                                    </li>
                                </ul>
                            </nav>
                        </Menu>
                    </div>


                    <nav className="hidden lg:block" id="page-wrap">
                        <ul className="gap-4 flex">
                            <li><Link
                                to="ebaut"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Про івент</Link>
                            </li>
                            <li><Link
                                to="speacers"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Спікери</Link>
                            </li>
                            <li><Link
                                to="programm"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Програма</Link>
                            </li>
                            <li><Link
                                to="formats"
                                id="head_paketu_clk"
                                onClick={toggleMenu}
                                smooth={true}
                                offset={-70}
                                duration={500}>Формати участі</Link>
                            </li>
                        </ul>
                    </nav>

                    <Link to="formats" spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          className="bg-red-500 hover:bg-red-700 text-white font-normal uppercase py-2 px-4 rounded inline-flex items-center border-b-4 border-red-900">
                        <IoTicket className="font-bold text-2xl mr-2"/>
                        <span>Взяти<span className="sm:inline hidden"> участь</span></span>
                    </Link>
                </div>

            </header>
        </>
    )
}

export default Header;